export const getEnv = () => {
  // adding this to resolve build failure.
  const metaEnvironment = import.meta.env;
  return metaEnvironment;
};

export const getModuleBaseUrl = () => {
  const url = new URL(import.meta.url);
  url.pathname = '/';
  return url.href;
};
